"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "caserta": {
    "679432bb": [{
      "hkey": "1f130d9c",
      "slug": "briano-sala-san-leucio",
      "name": "Briano-Sala-San Leucio",
      "primary": true,
      "skipSearch": false
    }],
    "briano": [{
      "hkey": "1f130d9c",
      "slug": "briano-sala-san-leucio",
      "name": "Briano-Sala-San Leucio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6fccd981": [{
      "hkey": "afb6124e",
      "slug": "parco-cerasole-stadio",
      "name": "Parco Cerasole-Stadio",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "40404eb3",
      "slug": "parco-degli-aranci-tredici",
      "name": "Parco degli Aranci-Tredici",
      "primary": false,
      "skipSearch": false
    }],
    "caserta-2-centuriano-cerasola-167": [{
      "hkey": "afb6124e",
      "slug": "parco-cerasole-stadio",
      "name": "Parco Cerasole-Stadio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caserta"
    }],
    "ff86f8d8": [{
      "hkey": "3607b7b4",
      "slug": "acquaviva-lincoln",
      "name": "Acquaviva-Lincoln",
      "primary": true,
      "skipSearch": false
    }],
    "caserta-ferrarecce-acquaviva-lincoln": [{
      "hkey": "3607b7b4",
      "slug": "acquaviva-lincoln",
      "name": "Acquaviva-Lincoln",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "93c11561": [{
      "hkey": "e28f51c4",
      "slug": "casolla-mezzano-tuoro",
      "name": "Casolla-Mezzano-Tuoro",
      "primary": true,
      "skipSearch": false
    }],
    "casolla": [{
      "hkey": "e28f51c4",
      "slug": "casolla-mezzano-tuoro",
      "name": "Casolla-Mezzano-Tuoro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0fe44588": [{
      "hkey": "afb6124e",
      "slug": "parco-cerasole-stadio",
      "name": "Parco Cerasole-Stadio",
      "primary": true,
      "skipSearch": false
    }],
    "centurano": [{
      "hkey": "afb6124e",
      "slug": "parco-cerasole-stadio",
      "name": "Parco Cerasole-Stadio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caserta"
    }],
    "f87e0086": [{
      "hkey": "91c32935",
      "slug": "ercole-ospedale-via-ruggiero",
      "name": "Ercole-Ospedale-Via Ruggiero",
      "primary": true,
      "skipSearch": false
    }],
    "ercole": [{
      "hkey": "91c32935",
      "slug": "ercole-ospedale-via-ruggiero",
      "name": "Ercole-Ospedale-Via Ruggiero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "45356895": [{
      "hkey": "e28f51c4",
      "slug": "casolla-mezzano-tuoro",
      "name": "Casolla-Mezzano-Tuoro",
      "primary": true,
      "skipSearch": false
    }],
    "mezzano": [{
      "hkey": "e28f51c4",
      "slug": "casolla-mezzano-tuoro",
      "name": "Casolla-Mezzano-Tuoro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caserta"
    }],
    "f4b444a4": [{
      "hkey": "91c32935",
      "slug": "ercole-ospedale-via-ruggiero",
      "name": "Ercole-Ospedale-Via Ruggiero",
      "primary": true,
      "skipSearch": false
    }],
    "ospedale": [{
      "hkey": "91c32935",
      "slug": "ercole-ospedale-via-ruggiero",
      "name": "Ercole-Ospedale-Via Ruggiero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caserta"
    }],
    "a0a5f997": [{
      "hkey": "e28f51c4",
      "slug": "casolla-mezzano-tuoro",
      "name": "Casolla-Mezzano-Tuoro",
      "primary": true,
      "skipSearch": false
    }],
    "petrarelle": [{
      "hkey": "e28f51c4",
      "slug": "casolla-mezzano-tuoro",
      "name": "Casolla-Mezzano-Tuoro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caserta"
    }],
    "2b76b281": [{
      "hkey": "94f4ff45",
      "slug": "caserta",
      "name": "Caserta",
      "primary": true,
      "skipSearch": false
    }],
    "piedimonte-di-casolla": [{
      "hkey": "94f4ff45",
      "slug": "caserta",
      "name": "Caserta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fc359b05": [{
      "hkey": "e2fbd18d",
      "slug": "casola",
      "name": "Casola",
      "primary": true,
      "skipSearch": false
    }],
    "pozzovetere": [{
      "hkey": "e2fbd18d",
      "slug": "casola",
      "name": "Casola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caserta"
    }],
    "5eee448a": [{
      "hkey": "1f130d9c",
      "slug": "briano-sala-san-leucio",
      "name": "Briano-Sala-San Leucio",
      "primary": true,
      "skipSearch": false
    }],
    "sala": [{
      "hkey": "1f130d9c",
      "slug": "briano-sala-san-leucio",
      "name": "Briano-Sala-San Leucio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caserta"
    }],
    "c98b7b77": [{
      "hkey": "23fa2628",
      "slug": "falciano",
      "name": "Falciano",
      "primary": true,
      "skipSearch": false
    }],
    "san-benedetto": [{
      "hkey": "23fa2628",
      "slug": "falciano",
      "name": "Falciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caserta"
    }],
    "3f732f26": [{
      "hkey": "1f130d9c",
      "slug": "briano-sala-san-leucio",
      "name": "Briano-Sala-San Leucio",
      "primary": true,
      "skipSearch": false
    }],
    "san-leucio": [{
      "hkey": "1f130d9c",
      "slug": "briano-sala-san-leucio",
      "name": "Briano-Sala-San Leucio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caserta"
    }],
    "0ed93aec": [{
      "hkey": "94f4ff45",
      "slug": "caserta",
      "name": "Caserta",
      "primary": true,
      "skipSearch": false
    }],
    "santa-barbara": [{
      "hkey": "94f4ff45",
      "slug": "caserta",
      "name": "Caserta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8094854e": [{
      "hkey": "e2fbd18d",
      "slug": "casola",
      "name": "Casola",
      "primary": true,
      "skipSearch": false
    }],
    "sommana": [{
      "hkey": "e2fbd18d",
      "slug": "casola",
      "name": "Casola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caserta"
    }],
    "fcc06007": [{
      "hkey": "94f4ff45",
      "slug": "caserta",
      "name": "Caserta",
      "primary": true,
      "skipSearch": false
    }],
    "staturano": [{
      "hkey": "94f4ff45",
      "slug": "caserta",
      "name": "Caserta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7f6cdd18": [{
      "hkey": "40404eb3",
      "slug": "parco-degli-aranci-tredici",
      "name": "Parco degli Aranci-Tredici",
      "primary": true,
      "skipSearch": false
    }],
    "tredici": [{
      "hkey": "40404eb3",
      "slug": "parco-degli-aranci-tredici",
      "name": "Parco degli Aranci-Tredici",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b9c46218": [{
      "hkey": "e28f51c4",
      "slug": "casolla-mezzano-tuoro",
      "name": "Casolla-Mezzano-Tuoro",
      "primary": true,
      "skipSearch": false
    }],
    "tuoro": [{
      "hkey": "e28f51c4",
      "slug": "casolla-mezzano-tuoro",
      "name": "Casolla-Mezzano-Tuoro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caserta"
    }],
    "0231503f": [{
      "hkey": "1f130d9c",
      "slug": "briano-sala-san-leucio",
      "name": "Briano-Sala-San Leucio",
      "primary": true,
      "skipSearch": false
    }],
    "vaccheria": [{
      "hkey": "1f130d9c",
      "slug": "briano-sala-san-leucio",
      "name": "Briano-Sala-San Leucio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caserta"
    }]
  }
};
exports["default"] = _default;